

<div class="" *ngIf="calendarItem != undefined">
   
    <div *ngFor="let obj of calendarItem.Hyperlinks" class="dateRow gridRow row"> 
        <div class="col-sm-12"> 
            <app-calendar-item-edit-urls-detail [link]="obj" [calendarItemId]="calendarItem.Id" (linksUpdated)="updateLinks()" ></app-calendar-item-edit-urls-detail>
        </div>
    </div>
 
    <div *ngIf="showAddNewLink == true" class="dateRow gridRow row">
        <div class="col-sm-12"> 
            <app-calendar-item-edit-urls-detail [link]="" [calendarItemId]="calendarItem.Id" (linksUpdated)="updateLinks()" ></app-calendar-item-edit-urls-detail>
        </div>
    </div>

  <div (click)="addNew()" class="btn-link" style="margin-top:10px">Add New Link</div>

</div>